import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import ArrowHelp from '../../../../../../assets/icons/Arrows-chevron/ArrowHelp.svg'
import { PurchasedCourseTopicState } from '../../../../../../features/types'
import { flexWrap, helpBox, helpIcon, tabTitle } from '../../style'
import { SelectedSubjectState } from '../../types'
import SelectTopicCard from './SelectTopicCard'

interface Props {
    selectedLanguage: string
    selectedSubjects: SelectedSubjectState[]
    coursePriceId: number
    promotionDiscount: number
    queryParamsExists: boolean
    queryCourseSubjectId: number
    handleToggleAllTopics: (subjectId: number) => void
    onSelectTopics: (
        topics: PurchasedCourseTopicState[],
        subjectId: number,
    ) => void
    onTopicClick: (
        topic: PurchasedCourseTopicState,
        subjectId: number,
        topics?: PurchasedCourseTopicState[],
    ) => void
}

const SelectTopicTab: React.FC<Props> = ({
    selectedSubjects,
    selectedLanguage,
    coursePriceId,
    promotionDiscount,
    queryParamsExists,
    queryCourseSubjectId,
    onTopicClick,
    handleToggleAllTopics,
    onSelectTopics,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <Box sx={tabTitle}>
                {formatMessage({ id: 'chooseTopicOfSubjects' })}
            </Box>

            <Box sx={helpBox}>
                <img
                    style={helpIcon as React.CSSProperties}
                    src={ArrowHelp}
                />
                <Box sx={{ ml: 7 }}>
                    {formatMessage({ id: 'canChooseEachTopic' })}
                </Box>
            </Box>

            <Box sx={flexWrap}>
                {selectedSubjects.map((selectedSubject, index) => (
                    <SelectTopicCard
                        selectedLanguage={selectedLanguage}
                        key={index}
                        promotionDiscount={promotionDiscount}
                        subject={selectedSubject}
                        queryCourseSubjectId={queryCourseSubjectId}
                        coursePriceId={coursePriceId}
                        queryParamsExists={queryParamsExists}
                        onTopicClick={onTopicClick}
                        onSelectTopics={onSelectTopics}
                        handleToggleAllTopics={handleToggleAllTopics}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default SelectTopicTab
